export default "__VITE_ASSET__C9n$lu4j__"